import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { COUNTRY_CODE_HEADER_WHITELIST_URLS } from '../constants/market-header.constant';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { isPlatformServer } from '@angular/common';

@Injectable()
export class MarketHeaderInterceptor implements HttpInterceptor {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(REQUEST) private webAppBuyerRequest: any,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (isPlatformServer(this.platformId) && this.includeMarketHeader(request.url)) {
      const spiReq = request.clone({
        setHeaders: {
          'Country-Code': getCountryDomainCode(this.webAppBuyerRequest),
        }
      });
      return next.handle(spiReq);
    }

    if (!this.includeMarketHeader(request.url)) {
      return next.handle(request);
    }

    return next.handle(request.clone({
      setHeaders: {
        'Country-Code': getCountryDomainCode(this.webAppBuyerRequest),
      }
    }));
  }

  private includeMarketHeader(requestUrl: string): boolean {
    return COUNTRY_CODE_HEADER_WHITELIST_URLS().some(whitelistedUrl => requestUrl.startsWith(whitelistedUrl));
  }

}
